<template>
  <div>
    <section>
      <v-navigation-drawer
        dark
        color="#ff64ad"
        width="75"
        v-model="drawer"
        fixed
        app>
        <v-list
          v-for="(item, index) in list.menu"
          :key="index">
          <v-list-item class="px-2">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  color="transparent"
                  flat
                  class="cursor-pointer ma-auto"
                  v-bind="attrs"
                  v-on="on"
                  :to="item.link">
                  <v-card-title 
                    class="justify-center pt-3 pb-1">
                    <v-icon :color="item.link.split('/')[1] === $route.path.split('/')[1] ? '#ffffff' : '#ffffff80'">
                      {{ item.icon }}
                    </v-icon>
                  </v-card-title>
                  
                  <v-card-text 
                    class="text-center one-line pa-0" 
                    style="font-size: 10px;"
                    :class="item.link.split('/')[1] === $route.path.split('/')[1] ? 'white--text font-weight-bold' : ''">
                    {{ item.label }}
                  </v-card-text>
                </v-card>
              </template>

              <span>
                {{ item.label }}
              </span>
            </v-tooltip>

            <v-divider
              vertical
              inset
              class="my-4"
              v-if="item.link.split('/')[1] === $route.path.split('/')[1]"
              style="border-width: 5px; border-color: #ffffff; border-radius: 25px; position: absolute; height: 40px; top: 1px; right: -5px;">
            </v-divider>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar
        :clipped-left="clipped"
        color="#fff"
        fixed
        nav
        elevation="0"
        app>
        <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/>
        
        <v-toolbar-title 
          class="body-2 pl-5 d-flex align-center">
          <span class="font-weight-bold black--text">
            SAKURA
          </span>

          <span class="text-second ml-1">
            (Administrasi Kependudukan)
          </span>

          <v-divider
            class="mx-3"
            vertical
            style="min-height: 25px !important;
            height: 25px
            min-width: 3px;
            margin-top: auto;
            margin-bottom: auto;
            background: #dadada;">
          </v-divider>

          <span class="text-second">
            {{ $route.meta.title }}
          </span>
        </v-toolbar-title>

        <v-spacer/>

        <!-- <router-link to="/news"
          class="cursor-pointer">
          <v-badge v-if="total > 0"
            color="red"
            overlap
            dot
            offset-y="10"
            offset-x="10">
            <span slot="default">
              <v-icon color="orange">mdi-bell</v-icon>
            </span>
          </v-badge>

          <span v-else
            slot="default">
            <v-icon color="grey">mdi-bell</v-icon>
          </span>
        </router-link> -->

        <v-menu
          close-on-content-click 
          nudge-width="250" 
          offset-x>
          <template v-slot:activator="{ on }">
            <div v-on="on" 
              @click="fetchNotification()"
              class="cursor-pointer">
              <v-badge v-if="total > 0"
                color="red"
                overlap>
                <span v-if="total > 9"
                  slot="badge">
                  9+
                </span>

                <span slot="badge" v-else>
                  {{ total }}
                </span>
                
                <span slot="default">
                  <v-icon color="orange">mdi-bell</v-icon>
                </span>
              </v-badge>

              <span v-else
                slot="default">
                <v-icon color="grey">mdi-bell</v-icon>
              </span>
            </div>
          </template>

          <v-card>
            <v-list 
              flat 
              dense 
              class="overflow-y-auto" 
              max-height="400" 
              max-width="300">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.load"
                transition="scale-transition"
                :tile="false"
                type="list-item-two-line"
                v-for="(item, index) in process.load ? 5 : list.notification" 
                :key="index">
                <v-list-item-group>
                  <v-list-item
                    @click="updateRead(item)">
                    <v-list-item-avatar
                      class="mr-1">
                      <v-icon
                        :color="!item.notification_is_read ? 'orange' : 'grey'">
                        mdi-bell
                      </v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.notification_title }}
                      </v-list-item-title>

                      <v-list-item-subtitle
                        class="caption font-weight-light">
                        {{ item.notification_create_datetime | ago }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-skeleton-loader>
            </v-list>

            <v-divider class="ma-3 my-0" v-if="!process.load && pagination.total_data > 5"/>

            <v-card-actions v-if="!process.load && pagination.total_data > 5">
              <v-btn
                block
                rounded
                color="#ff64ad"
                class="text-capitalize"
                text
                to="/notification">
                Lihat Semua
              </v-btn>
            </v-card-actions>

            <Empty v-if="!process.load && pagination.total_data < 1"
              margin="my-0"
              padding="pa-0"
              font="body-2"
              size="100"
              message="Pemberitahuan" />
          </v-card>
        </v-menu>

        <div 
          class="ml-4 mr-1 hidden-md-and-down">
          <v-menu
            :close-on-click="true"
            :close-on-content-click="true"
            :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <v-list 
                flat
                class="py-0" 
                color="#ff64ad" 
                style="border-radius: 50px;">
                <v-list-item 
                  to="/profile"
                  flat
                  class="pl-2" 
                  v-bind="attrs"
                  v-on="on"
                  style="border-radius: 50px;">
                  <v-list-item-avatar 
                    size="35" 
                    color="white" 
                    class="my-0" 
                    style="border: 3px solid #fff;">
                    <v-img alt="vuetify"
                      :src="user.image === '' ? require('@/assets/image/member-default.jpg') : user.image">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="#ff64ad">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-list-item-avatar>

                  <v-list-item-content class="py-0 white--text" style="width: 150px;">
                    <v-list-item-title 
                      class="body-2 font-weight-bold text-capitalize pt-0">
                      {{ user.fullname }}
                    </v-list-item-title>

                    <v-list-item-subtitle 
                      class="font-weight-light white--text pb-0" 
                      style="font-size: 10px;">
                      {{ user.email }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-menu>
        </div>

        <!-- <v-menu
          close-on-content-click 
          nudge-width="150" 
          offset-x>
          <template v-slot:activator="{ on }">
            <v-card-title 
              v-on="on"
              class="justify-center pl-2 cursor-pointer">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-card-title>
          </template>

          <v-list shaped dense class="body-2">
            <v-list-item @click="reloaded">
              <v-list-item-icon class="mr-3">
                <v-icon size="20">
                  {{ !JSON.parse(reload) ? 'mdi-refresh-auto' : 'mdi-reload' }}
                </v-icon>
              </v-list-item-icon>

              <v-list-item-title>
                Reload {{ !JSON.parse(reload) ? 'Otomatis' : 'Manual' }}
              </v-list-item-title>
            </v-list-item>

            <v-divider class="mx-4" />

            <v-list-item @click="logout">
              <v-list-item-icon class="mr-3">
                <v-icon size="20" color="red">mdi-logout-variant</v-icon>
              </v-list-item-icon>

              <v-list-item-title class="red--text">
                Keluar
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->

        <!-- <div 
          class="cursor-pointer hidden-md-and-down"
          @click="logout">
          <v-card-title 
            class="justify-center pl-2">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-card-title>
        </div> -->

        <div 
          class="pr-6 cursor-pointer hidden-md-and-down"
          @click="logout">
          <v-card-title 
            class="justify-center pt-1 pb-0">
            <v-icon color="red">mdi-logout-variant</v-icon>
          </v-card-title>

          <v-card-text 
            class="text-center pa-0 red--text" 
            style="font-size: 10px;">
            Keluar
          </v-card-text>
        </div>
      </v-app-bar>
    </section>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        clipped: false,
        drawer: true,
        total: 0,
        list: {
          menu: [],
          notification: []
        },
        pagination: {
          total_data: 0
        },
        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      menu () {
        return this.$store.state.menu
      },
      reload () {
        return this.$store.state.reload
      }
    },
    created () {
      if (process.browser) {
        if ('Notification' in window && 'serviceWorker' in navigator) {
          navigator.serviceWorker.addEventListener('message', event => {
            console.log(event)

            this.fetchCount()
          })
        }
      }
    },
    mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      }

      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }

      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      this.fetch()
    },
    methods: {
      fetch () {
        this.fecthMenu()
        this.fetchCount()
      },
      async fecthMenu () {
        await get('admin/general/menu')
        .then(response => {
          let res = response.data
          
          if (res.code === 200) {
            this.list.menu = res.data
          }
        })
      },
      async fetchNotification () {
        this.process.load = true

        let params = {
          limit: 10
        }

        await get('notification', { params }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.code === 200) {
            this.list.notification = res.data
            this.pagination = res.pagination
          }
        })
      },
      async fetchCount () {
        await get('notification/count').then(response => {
          let res = response.data

          if (res.code === 200) {
            this.total = res.data.unread
          }
        })
      },
      async updateRead (item) {
        await post(`notification/is_read`, {
          data: {
            ids: [item.notification_id]
          }
        })
        .then(response => {
          window.location.href = item.notification_type === 'report' ? `/news/${item.notification_extra.content_id}` : `/${item.notification_type}`
        })
      },
      reloaded () {
        let data = JSON.parse(this.reload)
        TokenService.saveReload(!data ? true : false)

        location.reload()
      },
      async logout () {
        TokenService.removeToken()
            
        window.location = '/login'
      }
    }
  }
</script>